import { DEFAULT_CURRENCY_CODE, enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { browserTracingIntegration } from '@sentry/angular';

import { AppModule } from '@app/app.module';
import { PuSubscribe } from '@app/utils/pu-subscribe';
import './app/modules/shared/utils/storage-quota.guard';

import { environment } from './environments/environment';
import { EnvironmentType } from './environments/environment-config';

if (window.location.hostname !== 'localhost') {
  const apiOrigin = new URL(environment.apiUrl).origin;

  Sentry.init({
    dsn: environment.sentryUrl,
    integrations: [browserTracingIntegration()],
    tracePropagationTargets: [apiOrigin, /^\//],
    tracesSampleRate: 1.0,
    environment: EnvironmentType[environment.type].toLowerCase(),
  });
}

if (environment.type === EnvironmentType.Prod) {
  enableProdMode();
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js')
    .then(reg => {
      // eslint-disable-next-line no-console
      console.info('[SW] registered with scope:', reg.scope);

      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          // eslint-disable-next-line no-console
          console.info('[SW] new worker state:', newWorker.state);
        });
      });
    })
    .catch(err => {
      console.warn('[SW] registration failed:', err);
    });

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // eslint-disable-next-line no-console
    console.info('[SW] controller changed (new SW controlling this page).');
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    providers: [
      { provide: DEFAULT_CURRENCY_CODE, useValue: 'USD' },
      {
        provide: PuSubscribe,
        useValue: new PuSubscribe(),
      },
    ],
  })
  .catch(err => console.error(err));
